import React from 'react';
import './AppLoader.css'
import DownloadIcon from "../../static/dc.gif";

function AppLoader() {
    return (
        <div className='appln_loader' >
            <img style={{ width: '200px', position: 'relative', top: '35%' }} src={DownloadIcon} />
        </div >
    );
}

export default AppLoader;